import React from 'react';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import Logo from 'assets/images/logo/logomark.svg';

import defaultPath from 'config/paths';

// MUI
import { styled } from '@mui/material/styles';

const LOGO_SIZE = 70;
const LOGO_PADDING = 1;
export const FULL_LOGO_HEIGHT = LOGO_SIZE + LOGO_PADDING * 2;

const StyledLink = styled(Link)({
  display: 'block',
  padding: LOGO_PADDING,
  height: LOGO_SIZE,
  width: '100%',
  backgroundSize: 'contain',
  backgroundRepeat: 'no-repeat',
  backgroundPosition: 'center',
  backgroundOrigin: 'content-box',
});

const CompanyLogo = ({ logo }) => {
  return (
    <StyledLink to={defaultPath} style={{ backgroundImage: `url("${logo}")` }}>
      <div />
    </StyledLink>
  );
};

const mapStateToProps = ({ profile }) => {
  const logo = profile?.company?.logo ?? Logo;
  return { logo };
};

export default connect(mapStateToProps)(CompanyLogo);
